// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.feedlistingmanagement.RentalManagerUserFeedListingManagementWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreateManualVersionResponseWebDto, GetListingSourcesResponseWebDto, ListingAlias } from '../..';

interface CreateManualVersionParams {
  listingAlias: ListingAlias;
}
interface GetListingSourcesParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserFeedListingManagementWebApiHandler_createManualVersion_Path =
  '/api/web/v1/users/properties/feedListingManagement/createManualVersion';

/**
 * Create manual version of the listing
 */
export const RentalManagerUserFeedListingManagementWebApiHandler_createManualVersion = (
  getParams: CreateManualVersionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CreateManualVersionParams, never, CreateManualVersionResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFeedListingManagementWebApiHandler_createManualVersion_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_Path =
  '/api/web/v1/users/properties/feedListingManagement/getListingSources';

/**
 * Get listing sources of a listing
 */
export const RentalManagerUserFeedListingManagementWebApiHandler_getListingSources = (
  getParams: GetListingSourcesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetListingSourcesParams, never, GetListingSourcesResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
